<template>
  <div id="project-info">
    <div class="project-info-wrapper">
      <div class="project-info-box">
        <div class="panel__header">
          <div class="project-info-title flex:1">
            项目信息
          </div>
          <div class="head-btn">
            <button type="button" class="qrcode_handle_btn" @click="ProjectInfoOpinion">
              编辑
            </button>
          </div>
        </div>

        <div class="panel__body">
          <div class="project-image-box">
            <div class="left-title" style="margin-bottom: 20px">
              项目图片
            </div>
            <div class="project-image-wrapper">
              <el-image
                class="project-image"
                :src="imageUrl"
                alt="项目图片"
                :preview-src-list="showImageList"
              ></el-image>
            </div>
          </div>
          <div class="project-info-content">
            <div class="left-title">
              项目名称
            </div>
            <div class="content-text qrcode_input">
              <span> {{ projectData.Name }}</span>
            </div>
          </div>

          <div class="project-info-content">
            <div class="left-title">
              项目编码
            </div>
            <div class="content-text qrcode_input">
              <span> {{ projectData.ProjectCode || '' }}</span>
            </div>
          </div>

          <div class="project-info-content">
            <div class="left-title">
              项目描述
            </div>
            <div class="content-text qrcode_input">
              <span> {{ projectData.Description || '' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="project-info-set">
        <div class="panel__header">
          <div>项目设置</div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      title="编辑项目信息"
      width="600px"
    >
      <div class="flex flex1 column qrcode-from">
        <el-form ref="formData" :model="saveProjectForm" :rules="rules" :show-message="false">
          <div class=" b-flex-space-between">
            <el-form-item label="项目名称" prop="ProjectName">
              <el-input
                v-model="saveProjectForm.ProjectName"
                class="project-info__input"
              ></el-input>
            </el-form-item>
          </div>
          <div class=" b-flex-space-between">
            <el-form-item label="项目编码" prop="ProjectCode">
              <el-input
                v-model="saveProjectForm.ProjectCode"
                class="project-info__input"
              ></el-input>
            </el-form-item>
          </div>
          <div class=" b-flex-space-between">
            <el-form-item label="项目描述" prop="Description">
              <el-input
                v-model="saveProjectForm.Description"
                type="textarea"
                class="project-info__input"
              ></el-input>
            </el-form-item>
          </div>
          <div class=" b-flex-space-between">
            <el-form-item label="项目图片">
              <el-upload
                action=""
                class="avatar-uploader"
                accept=".jpg,image/png"
                :show-file-list="false"
                :on-change="fileChange"
              >
                <img v-if="uploadImageUrl" :src="uploadImageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div slot="footer" class="b-flex" style="justify-content: flex-end;">
        <button class="qrcode_handle_btn" type="button" title="保存" @click="toSaveBtn">
          保存
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// let _this = void 0
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ProjectInfo',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      projectData: {},
      saveProjectForm: {
        ProjectName: '',
        ProjectCode: '',
        Description: '',
      },
      rules: {
        ProjectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
      },
      // 网络请求图片的url
      imageUrl: '',
      // 上传图片的url
      uploadImageUrl: '',
      imageFile: [],
      dialogVisible: false,
      // 点击浏览图片的url
      showImageList: [],
    }
  },
  computed: {
    ...mapState({
      PROJECT_ID: state => state.PROJECT_ID,
    }),
  },
  watch: {
    isUpdate(val) {
      this.updateOrSaveText = val ? '编辑' : '保存'
    },
  },
  created() {
    // _this = this
  },
  mounted() {
    this.getProjectInfo()
  },
  destroy() {},
  methods: {
    ...mapGetters({
      projectId: 'getProjectId',
    }),
    /*
     * 根据项目ID获取项目信息
     * */
    async getProjectInfo() {
      const { success, data } = await this.$http({
        url: this.$api.getCurrentProject,
      })
      if (success) {
        const { rows } = data
        this.saveProjectForm.ProjectName = rows[0].Name
        this.saveProjectForm.ProjectCode = rows[0].ProjectCode || ''
        this.saveProjectForm.Description = rows[0].Description || ''
        this.projectData = { ...rows[0] }
        this.setProjectImage(rows[0])
      } else {
        this.$message({
          type: 'error',
          message: '获取项目信息失败！',
        })
      }
    },
    /*
     * 设置项目图片
     * @parma data {object} 项目信息
     * */
    setProjectImage(data) {
      const { DefaultProjectImagePath, DefaultProjectThumbnailPath } = data
      const BASE_URL = `${WEB_CONFIG.SERVER_URL}`
      if (DefaultProjectImagePath) {
        this.imageUrl = BASE_URL + DefaultProjectImagePath
      } else if (DefaultProjectThumbnailPath) {
        this.imageUrl = BASE_URL + DefaultProjectThumbnailPath
      } else {
        this.imageUrl =
          'http://bimissue.alphabim.net/Areas/ProjectList/Content/images/ProjectList/projectDefaultImg.png'
      }
      this.uploadImageUrl =
        DefaultProjectImagePath || DefaultProjectThumbnailPath ? this.imageUrl : ''
      this.showImageList.push(this.imageUrl)
    },
    /*
     * 项目信息编辑
     * */
    ProjectInfoOpinion() {
      this.dialogVisible = true
    },
    /*
     * 上传文件，选择图片
     * */
    fileChange(file) {
      this.uploadImageUrl = this.getObjectURL(file.raw)
      this.imageFile = file.raw
    },
    /*
     * 保存项目信息按钮
     * */
    toSaveBtn() {
      const { ProjectName } = this.saveProjectForm
      if (ProjectName) {
        this.commitUpdateProject()
      } else {
        this.$message({
          type: 'error',
          message: '请输入项目名称!',
        })
      }
    },
    /*
     * 修改项目信息
     * */
    async commitUpdateProject() {
      const projectID = this.projectId()
      const { ProjectName, ProjectCode, Description } = this.saveProjectForm
      const fd = new FormData()
      fd.append('ID', projectID)
      fd.append('Name', ProjectName)
      fd.append('ProjectCode', ProjectCode)
      fd.append('Description', Description)

      fd.append('upload_file', this.imageFile)
      const { success } = await this.$http({
        url: this.$api.updateCurrentProject,
        method: 'post',
        data: fd,
      })
      if (success) {
        this.dialogVisible = false
        await this.getProjectInfo()
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '修改成功！' : '修改错误！',
      })
    },
    /*
     * 兼容浏览器显示图片地址
     * */
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
  },
}
</script>
<style lang="scss" scoped>
#project-info {
  background: #f5f5f5;
  height: 100%;
  overflow: auto;
}
.project-info-wrapper {
  height: 100%;
  display: flex;
}
.project-info-box {
  flex: 1;
  background: #ffffff;
}
.project-info-set {
  flex: 3;
  margin-left: 1em;
  background: #ffffff;
  height: 100%;
}
// .project-info-title {
//   font-weight: 700;
//   font-size: 15px;
//   color: #888888;
// }
.head-btn {
  flex: 1;
  text-align: right;
}
.project-image-box {
  padding: 1em 0;
}
.left-title {
  text-align: left;
  color: #888888;
  font-weight: bold;
  font-size: 13px;
  width: 110px;
}
.project-image {
  max-width: 400px;
  max-height: 400px;
  margin-bottom: 20px;
}
.project-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.project-info-content {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #f5f5f5;
}
.content-text {
  color: rgb(136, 136, 136);
  font-size: 13px;
  width: 100%;
}
.project-info-set-head {
  font-weight: 700;
  font-size: 15px;
  color: #888888;
  height: 65px;
  border-bottom: 1px solid #f0f0f0;
  padding-left: 1em;
  box-sizing: border-box;
  line-height: 65px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 220px;
  line-height: 220px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
}
.avatar-uploader {
  height: 220px;
}
.avatar {
  width: 320px;
  height: 220px;
}
.project-info__input {
  width: 320px;
}
#project-info ::v-deep .qrcode-from .el-form-item__label {
  min-width: 100px;
  padding-right: 2em;
}
#project-info ::v-deep .qrcode-from .el-form-item__error {
  left: 100px;
  padding-right: 2em;
}
#project-info ::v-deep .el-textarea__inner {
  min-height: 80px !important;
  font-size: 14px;
  color: #222222;
}
</style>
<style lang="scss"></style>
